module.exports = __webpack_public_path__ + "static/media/1.ba45bf6a.png";